import { render } from "./DrafMessage.vue?vue&type=template&id=3da83aa2"
import script from "./DrafMessage.vue?vue&type=script&lang=js"
export * from "./DrafMessage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__